// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___2VJf","fullView":"styles_fullView__3aBsv"};